<template>
  <v-card flat>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" v-if="$can('do','POKO_KlienciProblemyEdycja')" @click="addNew">Dodaj problem</v-btn>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-title>Problemy pacjenta</v-card-title>
              <v-card-text>
                <v-data-table  :headers="problemyHeaders"
                               :no-data-text="'Brak danych'"
                               :loading="loading"
                               :items="problemy"
                               :footer-props="{itemsPerPageOptions:[20,50,100,200,500]}"
                               class="elevation-1">
                  <template v-slot:item="props">
                    <tr>
                      <td>{{props.item.nazwa}}</td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{on, attrs}">
                            <span v-bind="attrs" v-on="on">{{getPlainTextPreview(props.item.opis)}}</span>
                          </template>
                          <span v-html="props.item.opis"></span>
                        </v-tooltip>
                      </td>
                      <td>{{dateTimeFormat(props.item.createdate)}}</td>
                      <td>{{dateFormat(props.item.problem_data)}}</td>
                      <td>{{props.item.terapeuta}}</td>
                      <td>
                        <v-icon small class="mr-2" @click="deleteProblem(props.item.id)" v-if="props.item.id > 0 && $can('do','POKO_KlienciProblemyEdycja')" title="Usuń problem">fa-trash-alt</v-icon>
                        <v-icon small class="mr-2" @click="edit(props.item.id)" v-if="props.item.id > 0 && $can('do','POKO_KlienciProblemyEdycja')" title="Edytuj problem">fa-pencil-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-dialog v-model="showEditDialog" width="768" persistent>
      <ProblemEdit v-if="showEditDialog" :id="wybrane_id" :client="klient_id" @close="closeEditDialog"></ProblemEdit>
    </v-dialog>
  </v-card>
</template>

<script>
import * as dayjs from "dayjs";
import {clientService} from "@/services";
import ProblemEdit from "@/components/clients/ProblemEdit";
import swal from "sweetalert";

export default {
  name: "Problemy",
  components: {ProblemEdit},
  props: ["clientid"],
  data() {
    return {
      problemy: [],
      problemyHeaders: [
        {text: "Nazwa", value: "nazwa", sortable: true},
        {text: "Opis", value: "opis", sortable: true},
        {text: "Data dodania", value: "createdate", sortable: true},
        {text: "Data problemu", value: "problem_data", sortable: true},
        {text: "Terapeuta", value: "terapeuta", sortable: true},
        {text: "Akcje", value: "id", sortable: false},
      ],
      loading:false,
      showEditDialog: false,
      wybrane_id:0,
      klient_id:0
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
      });
    },
    getPlainTextPreview(html) {
      if (!html) return '';
      // Strip HTML tags and get plain text
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const plainText = tmp.textContent || tmp.innerText || '';
      // Return first 50 characters with ellipsis
      return plainText.length > 50 ? plainText.substring(0, 50) + '...' : plainText;
    },
    addNew() {
      this.wybrane_id = 0
      this.klient_id = this.clientid
      this.showEditDialog = true

    },
    edit(id) {
      this.wybrane_id = id
      this.klient_id = this.clientid
      this.showEditDialog = true
    },
    deleteProblem(id)
    {
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć ten problem?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          clientService.deleteProblem(id)
              .then(() => {
                this.getData()
              }).catch(() => {
              this.showError("Nie można usunąć problemu");
          });
        }
      });
    },
    closeEditDialog() {
      this.klient_id = this.clientid
      this.wybrane_id = 0
      this.showEditDialog = false

      this.getData()
    },
    dateTimeFormat(val) {
      if (val) {
        return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
    dateFormat(val) {
      if (val) {
        return dayjs(val).format('DD-MM-YYYY')
      }
      return ''
    },
    getData() {
      this.loading = true
      clientService.getProblemy(this.clientid).then(result => {
        this.problemy = result.data.result
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.showError('Błąd pobierania problemów pacjenta')
      })
    }
  }
}
</script>

<style scoped>

</style>